import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import ClinicApi from "api/master/clinic.api";
import ReportApi from "api/report.api";
import VoucherApi from "api/voucher/voucher.api";
import HeaderCard from "component/CardCustom/HeaderCard";
import Loading from "component/Loading";
import _ from "lodash";
import MainButton from "new-components/buttons/main-button";
import SelectInput from "new-components/inputs/select-input";
import TextInput from "new-components/inputs/text-input";
import PaginationTable from "new-components/pagination/pagination";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getBranch } from "utils/app.utils";
import { UseSnCode } from "utils/useSnCode";




export default function GiftVoucherPatient() {
    const { t } = useTranslation()

    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [search, setSearch] = useState('')
    const [branch, setBranch] = useState<any>([])
    const [branchId, setBranchId] = useState<any>(getBranch())
    const [giftVoucherList, setGiftVoucherList] = useState([])
    const [giftVoucherType, setGiftVoucherType] = useState<any>([])
    const [giftVoucherTypeId, setGiftVoucherTypeId] = useState("ALL")
    const [giftVoucherId, setGiftVoucherId] = useState("ALL")
    const [optionGiftVoucher, setOptionGiftVoucher] = useState<any>([])
    const [snType, setSnType] = useState(false)
    const [loading, setLoading] = useState<boolean>(true)

    const fetchGiftVoucherList = async () => {
        setLoading(true)
        const condition = {
            page: page,
            pageLimit: pageLimit,
            sortBy: 'approvalId',
            sortType: 'ASC',
            branchId: branchId,
            search: search,
            voucherTypeId: giftVoucherTypeId === "ALL" ? null : giftVoucherTypeId,
            voucherId: giftVoucherId === "ALL" ? null : giftVoucherId,
        }
        try {
            const resp: any = await ReportApi.reportGiftVoucherPatient(condition)
            if (resp.status === 200) {
                setRowCount(resp?.headers['x-total'] || 0)
                setGiftVoucherList(resp.data?.rows)
            } else {
                setGiftVoucherList([])
            }
        } catch (err) {
            console.log(err)
        }
        setLoading(false)
    }

    const fetchBranch = async () => {
        ClinicApi.findAllBranches()
            .then(({ data }) => setBranch(_.map(data, (item) => ({ value: item.branchId, name: item.branchName || item.branchNameEn })))).catch((e) => { return })
    }

    const fetchGiftVoucherType = async () => {
        VoucherApi.findAllType({
            page: 1,
            pageLimit: 100,
        }).then(({ data }) => setGiftVoucherType(_.map(data, (item) => ({ value: item.voucherTypeId, name: item.voucherTypeName })))).catch((e) => { return })
    }

    const fetchGiftVoucher = async () => {
        VoucherApi.findGiftVoucherList({
            voucherTypeId: giftVoucherTypeId === "ALL" ? null : giftVoucherTypeId
        }).then(({ data }) => setOptionGiftVoucher(_.map(data, (item) => ({ value: item.voucherId, name: item.voucherName })))).catch((e) => { return })
    }

    const handleSnCode = useCallback(() => {
        const fetchData = async () => {
            const sn = await UseSnCode()
            setSnType(sn)
        }
        fetchData()
    }, [snType])

    useEffect(() => {
        fetchGiftVoucherList()
    }, [page, pageLimit])


    useEffect(() => {
        fetchBranch()
        fetchGiftVoucherType()
        fetchGiftVoucher()
        handleSnCode()
    }, [])


    return (
        <Box>
            <Loading show={loading} />
            <HeaderCard text={t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.TITLE')} />
            <Box paddingX="24px" paddingY="16px">
                <Grid container spacing="16px">
                    <Grid item xs={12} sm={4} md={2}>
                        <TextInput onChange={(e) => setSearch(e.target.value)} fullWidth label={t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.SEARCH')} value={search} />
                    </Grid>
                    <Grid xs={12} sm={4} item md={2}>
                        <SelectInput onChange={(e) => setBranchId(e.target.value)} value={branchId} label={t('REPORT.FILTER.BRANCH')} options={branch} defaultValue={branch?.[0]?.branchId} />
                    </Grid>
                    <Grid xs={12} sm={4} item md={2}>
                        <SelectInput onChange={(e) => setGiftVoucherTypeId(e.target.value)} label={t('REPORT.FILTER.GIFT_VOUCHER_USED.TYPE')} options={[{ value: 'ALL', name: t('REPORT.FILTER.ALL') }, ...giftVoucherType]} defaultValue='ALL' />
                    </Grid>
                    <Grid xs={12} sm={4} item md={2}>
                        <SelectInput onChange={(e) => setGiftVoucherId(e.target.value)} label={t('REPORT.FILTER.GIFT_VOUCHER_USED.PROMOTION')} options={[{ value: 'ALL', name: t('REPORT.FILTER.ALL') }, ...optionGiftVoucher]} defaultValue="ALL" />
                    </Grid>
                    <Grid item xs={12} sm={8} md={4}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <MainButton onClick={() => fetchGiftVoucherList()} title={t('INPUT.SEARCH')} type="primary" variant="contained" style={{ width: '120px' }} />
                            {/* <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                                // if (e === 'Excel') onDownload()
                                // if (e === 'PDF') window.print()
                            }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} /> */}
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{ overflowX: 'auto', overflowY: 'hidden', marginTop: '16px' }}>
                    <TableContainer style={{ boxShadow: 'none', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                        <Table aria-label="simple table" sx={{ width: '100%' }}>
                            <TableHead sx={{ backgroundColor: "#2F4269", color: 'white', border: '1px solid #2F4269' }}>
                                <TableRow>
                                    <TableCell sx={{ color: "white", fontWeight: 500, fontSize: '16px', minWidth: '100px', textAlign: 'center' }}>{t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.NO')}</TableCell>
                                    <TableCell sx={{ color: "white", fontWeight: 500, fontSize: '16px', minWidth: '100px', textAlign: 'center' }}>{t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.PATIENT_CN_NUMBER')}</TableCell>
                                    <TableCell sx={{ color: "white", fontWeight: 500, fontSize: '16px', minWidth: '160px', textAlign: 'center' }}>{t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.BRANCH_CN_NUMBER')}</TableCell>
                                    {snType && <TableCell sx={{ color: "white", fontWeight: 500, fontSize: '16px' }}>{t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.PATIENT_SN_CODE')}</TableCell>}
                                    <TableCell sx={{ color: "white", fontWeight: 500, fontSize: '16px' }}>{t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.PATIENT_NAME')}</TableCell>
                                    <TableCell sx={{ color: "white", fontWeight: 500, fontSize: '16px' }}>{t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.GIFT_VOUCHER_TYPE')}</TableCell>
                                    <TableCell sx={{ color: "white", fontWeight: 500, fontSize: '16px' }}>{t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.GIFT_VOUCHER')}</TableCell>
                                    <TableCell sx={{ color: "white", fontWeight: 500, fontSize: '16px', textAlign: 'center' }}>{t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.COUNT_WAITING')}</TableCell>
                                    <TableCell sx={{ color: "white", fontWeight: 500, fontSize: '16px', textAlign: 'center' }}>{t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.COUNT_READY')}</TableCell>
                                    <TableCell sx={{ color: "white", fontWeight: 500, fontSize: '16px', textAlign: 'center' }}>{t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.COUNT_USED')}</TableCell>
                                    <TableCell sx={{ color: "white", fontWeight: 500, fontSize: '16px', textAlign: 'center' }}>{t('REPORT.TABLE.GIFT_VOUCHER_PATIENT.COUNT_EXPIRED')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {giftVoucherList.length === 0 ?
                                    <TableRow key={0} style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)', borderRight: '1px solid rgba(224, 224, 224, 1)' }}>
                                        <TableCell colSpan={11} sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'center' }}>{t('NOT_FOUND')}</TableCell>
                                    </TableRow>
                                    :
                                    giftVoucherList.map((data: any, index: number) => (
                                        <TableRow key={index} style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)', borderRight: '1px solid rgba(224, 224, 224, 1)' }}>
                                            <TableCell sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'center' }}>{page * pageLimit - pageLimit + index + 1}</TableCell>
                                            <TableCell sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'center' }}>{data?.cnNumber || "-"}</TableCell>
                                            <TableCell sx={{ fontSize: '16px', fontWeight: 400, textAlign: 'center' }}>{data?.branchCnNumber || "-"}</TableCell>
                                            {snType && <TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.snCode || "-"}</TableCell>}
                                            <TableCell sx={{ fontSize: '16px', fontWeight: 400, minWidth: '250px' }}>{data?.patientName || "-"}</TableCell>
                                            <TableCell sx={{ fontSize: '16px', fontWeight: 400, minWidth: '200px' }}>{data?.voucherTypeName || "-"}</TableCell>
                                            <TableCell sx={{ fontSize: '16px', fontWeight: 400, minWidth: '400px' }}>{data?.voucherName || '-'}</TableCell>
                                            <TableCell sx={{ fontSize: '16px', fontWeight: 400, minWidth: '150px', textAlign: 'center' }}>{data?.countWaiting || "-"}</TableCell>
                                            <TableCell sx={{ fontSize: '16px', fontWeight: 400, minWidth: '165px', textAlign: 'center' }}>{data?.countReady || "-"}</TableCell>
                                            <TableCell sx={{ fontSize: '16px', fontWeight: 400, minWidth: '150px', textAlign: 'center' }}>{data?.countUsed || "-"}</TableCell>
                                            <TableCell sx={{ fontSize: '16px', fontWeight: 400, minWidth: '150px', textAlign: 'center' }}>{data?.countExpired || "-"}</TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box marginTop="8px">
                        <PaginationTable
                            onChange={(_e, newPage) => setPage(newPage)}
                            onPerPageChange={(e) => {
                                setPageLimit(parseInt(e.target.value, 10))
                                setPage(1)
                            }}
                            page={page}
                            perPage={pageLimit}
                            totalPage={rowCount}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}